// extracted by mini-css-extract-plugin
export default {"component":"splash-screen_component__dpzsV"};